/* eslint-disable max-classes-per-file */
/* eslint-disable no-this-before-super */
/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import "phaser";
import { Entity } from './Entity'
import { loadImage, loadSpritesheet, createAnimation } from "./../modules/utiltes"
import { SoundManager } from "../ScenesHelpers/SoundManager";
export class EnemyLaser extends Entity {
    /** 
     * EnemyLaser constructor @param {object} scene -scene that enemy laser object belongs to- @param {number} x - value of enemy laser on x axis - @param {number} y - value of enemy laser on y axis - @param {String} key -contains key of EnemyLaser- @param {String} audio -contains audio of EnemyLaser- @param {number} speedx - assign speed of laser x axis - @param {number} speedy - assign speed of laser x axis -
     * loadAssets function : load asset on screen and it takes @param {object} scene -scene that enemy laser object belongs to-  @param {String} key -key of enemy laser asset-  @param {String} keyLink -path of asset location-
     * */
    constructor(scene, x, y, key, speedx, speedy, audio) {
        super(scene, x, y, key);
        this.key = key;
        this.audio = audio;
        this.body.velocity.x = speedx;
        this.body.velocity.y = speedy;
    }
    static loadAssets(scene, key, keyLink) {
        loadImage(scene, `${key}`, keyLink)
    }
}


export class EnemyFactor {
    create = (scene,
        x,
        y,
        key,
        type,
        level,
        enemyScaleX,
        enemyScaleY,
        speedX,
        speedY,
        enemyShootkey,
        enemyShootSpeedX,
        enemyShootSpeedY,
        EnemyClass) => {
        switch (EnemyClass) {
            case Enemy:
                return new Enemy(scene, x, y, key, type, level, enemyScaleX, enemyScaleY, speedX, speedY, enemyShootkey, enemyShootSpeedX, enemyShootSpeedY)
            case NormalEnemy:
                return new NormalEnemy(scene, x, y, key, type, level, enemyScaleX, enemyScaleY, speedX, speedY, enemyShootkey, enemyShootSpeedX, enemyShootSpeedY)
            case ChaserEnemy:
                return new ChaserEnemy(scene, x, y, key, type, level, enemyScaleX, enemyScaleY, speedX, speedY, enemyShootkey, enemyShootSpeedX, enemyShootSpeedY)
            case BossEnemy:
                return new BossEnemy(scene, x, y, key, type, level, enemyScaleX, enemyScaleY, speedX, speedY, enemyShootkey, enemyShootSpeedX, enemyShootSpeedY)
        }
    }
}

export class Enemy extends Entity {
    /** 
     * Enemy constructor @param {object} scene -scene that enemy object belongs to- @param {number} x - value of enemy on x axis - @param {number} y - value of enemy on y axis - @param {String} key -contains key of Enemy- @param {String} type -type of enemy - @param {number} level -level of enemy- @param {number} EnemyScalex -scale enemy in x axis- @param {number} EnemyScaley -scale enemy in y axis- @param {number} speedx - assign speed of enemy x axis - @param {number} speedy - assign speed of enemy x axis -
     * loadAssets function : load asset on screen and it takes @param {object} scene -scene that enemy laser object belongs to-  @param {String} key -key of enemy laser asset-  @param {String} keyLink -path of asset location- @param {number} framex - number of frames of animation of x axis- @param {number} framey - number of frames of animation of y axis-
     * loadAnime function :  createAnimation  @param {Object} scene @param {object} scene -scene that enemy laser object belongs to- @param {String} key -key of enemy laser asset-  @param {number} framex - number of frames of animation of x axis-
     * */
    constructor(
        scene,
        x,
        y,
        key,
        type,
        level,
        enemyScaleX,
        enemyScaleY,
        speedX,
        speedY,
        enemyShootkey,
        enemyShootSpeedX,
        enemyShootSpeedY
    ) {
        super(scene, x, y, key, type);
        this.scene = scene
        this.x = x
        this.y = y
        this.key = key
        this.type = type
        this.level = level
        this.scaleX = enemyScaleX;
        this.scaleY = enemyScaleY;
        this.enemyShootkey = enemyShootkey
        this.enemyShootSpeedX = enemyShootSpeedX
        this.enemyShootSpeedY = enemyShootSpeedY
        this.setData("enemykey", key);
        this.setData("enemylevel", level);
        this.body.velocity.x = speedX;
        this.body.velocity.y = speedY;
    }
    static loadAssets(scene, key, keyLink, framex, framey) {
        loadSpritesheet(scene, `${key}`, keyLink, framex, framey)
    }
    static loadAnime(scene, key, framex) {
        createAnimation(scene, `${key}`, framex, -1)
    }
    applyEnemyAction() {}
}

export class NormalEnemy extends Enemy {
    /** 
     * NormalEnemy constructor @param {object} scene -scene that enemy object belongs to- @param {number} x - value of enemy on x axis - @param {number} y - value of enemy on y axis - @param {String} key -contains key of Enemy- @param {String} type -type of enemy - @param {number} level -level of enemy- @param {number} EnemyScalex -scale enemy in x axis- @param {number} EnemyScaley -scale enemy in y axis- @param {number} speedx - assign speed of laser x axis - @param {number} speedy - assign speed of laser x axis -
     * onDestroy : remove object that create enemy before destruction
     * */
    constructor(
        scene,
        x,
        y,
        key,
        type,
        level,
        enemyScaleX,
        enemyScaleY,
        speedX,
        speedY,
        enemyShootkey,
        enemyShootSpeedX,
        enemyShootSpeedY
    ) {
        super(
            scene,
            x,
            y,
            key,
            type,
            level,
            enemyScaleX,
            enemyScaleY,
            speedX,
            speedY,
            enemyShootkey,
            enemyShootSpeedX,
            enemyShootSpeedY
        );
    }
    applyEnemyAction() {
        const delay = 8000
        this.shootTimer = this.scene.time.addEvent({
            delay: delay,
            callback() {
                const laser = new EnemyLaser(
                    this.scene,
                    this.x,
                    this.y,
                    this.enemyShootkey,
                    this.enemyShootSpeedX,
                    this.enemyShootSpeedY,
                    "sprLaserEnemy0"
                );
                laser.setScale(this.scaleX);
                this.scene.enemyLasers.add(laser);
            },
            callbackScope: this,
            loop: true,
        });
    }
    onDestroy() {
        if (this.shootTimer !== undefined) {
            if (this.shootTimer) {
                this.shootTimer.remove(false);
            }
        }
    }
}

export class BossEnemy extends Enemy {
    /** 
     * BossEnemy constructor @param {object} scene -scene that enemy object belongs to- @param {number} x - value of enemy on x axis - @param {number} y - value of enemy on y axis - @param {String} key -contains key of Enemy- @param {String} type -type of enemy - @param {number} level -level of enemy- @param {number} EnemyScalex -scale enemy in x axis- @param {number} EnemyScaley -scale enemy in y axis- @param {number} speedx - assign speed of laser x axis - @param {number} speedy - assign speed of laser x axis -
     * onDestroy : remove object that create enemy before destruction
     * loadAssets function : load asset on screen and it takes @param {object} scene -scene that enemy laser object belongs to-  @param {String} key -key of enemy laser asset-  @param {String} keyLink -path of asset location- @param {number} framex - number of frames of animation of x axis- @param {number} framey - number of frames of animation of y axis-
     * loadAnime function :  createAnimation  @param {Object} scene @param {object} scene -scene that enemy laser object belongs to- @param {String} key -key of enemy laser asset-  @param {number} framex - number of frames of animation of x axis-
     * setBossIncrease : @param {number} Bossincrease -set Bossincrease -
     * getBossIncrease :get Bossincrease
     * */
    constructor(
        scene,
        x,
        y,
        key,
        type,
        level,
        enemyScaleX,
        enemyScaleY,
        speedX,
        speedY,
        enemyShootkey,
        enemyShootSpeedX,
        enemyShootSpeedY
    ) {
        super(
            scene,
            x,
            y,
            key,
            type,
            level,
            enemyScaleX,
            enemyScaleY,
            speedX,
            speedY,
            enemyShootkey,
            enemyShootSpeedX,
            enemyShootSpeedY
        );
        super.setTexture("boss");
        super.play("boss");
        this.setData("bosscounter", 0)
    }
    applyEnemyAction() {
        const delay = 2000
        this.shootTimer = this.scene.time.addEvent({
            delay: delay,
            callback() {
                const bossshootstraight = new EnemyLaser(
                    this.scene,
                    this.x,
                    this.y,
                    "bossshoot",
                    0,
                    200
                );
                this.scene.enemyLasers.add(bossshootstraight);
                const bossshootright = new EnemyLaser(
                    this.scene,
                    this.x,
                    this.y,
                    "bossshoot",
                    200,
                    200
                );
                this.scene.enemyLasers.add(bossshootright);
                const bossshootleft = new EnemyLaser(
                    this.scene,
                    this.x,
                    this.y,
                    "bossshoot", -200,
                    200
                );
                this.scene.enemyLasers.add(bossshootleft);
            },
            callbackScope: this,
            loop: true,
        });
    }
    onDestroy() {
        if (this.shootTimer !== undefined) {
            if (this.shootTimer) {
                this.shootTimer.remove(false);
            }
        }
    }
    static loadAssets(scene, key, keyLink, framex, framey) {
        loadSpritesheet(scene, `${key}`, keyLink, 60, 83)
    }
    static loadAnime(scene, key, framex) {
        createAnimation(scene, `${key}`, 60, -1)
    }
    static setBossIncrease(Bossincrease) {
        this.Bossincrease = Bossincrease
    }
    static getBossIncrease() {
        return this.Bossincrease
    }
}
export class ChaserEnemy extends Enemy {
    /**  ChaserEnemy constructor @param {object} scene -scene that enemy object belongs to- @param {number} x - value of enemy on x axis - @param {number} y - value of enemy on y axis - @param {String} key -contains key of Enemy- @param {String} type -type of enemy - @param {number} level -level of enemy- @param {number} EnemyScalex -scale enemy in x axis- @param {number} EnemyScaley -scale enemy in y axis- @param {number} speedx - assign speed of laser x axis - @param {number} speedy - assign speed of laser x axis -**/
    constructor(
        scene,
        x,
        y,
        key,
        type,
        level,
        enemyScaleX,
        enemyScaleY,
        speedX,
        speedY,
        enemyShootkey,
        enemyShootSpeedX,
        enemyShootSpeedY
    ) {
        super(
            scene,
            x,
            y,
            key,
            type,
            level,
            enemyScaleX,
            enemyScaleY,
            speedX,
            speedY,
            enemyShootkey,
            enemyShootSpeedX,
            enemyShootSpeedY
        );
        this.states = {
            MOVE_DOWN: "MOVE_DOWN",
            CHASE: "CHASE",
        };
        this.state = this.states.MOVE_DOWN;
    }

    update() {
        if (!this.getData("isDead") && this.scene.player) {
            if (
                Phaser.Math.Distance.Between(
                    this.x,
                    this.y,
                    this.scene.player.x,
                    this.scene.player.y
                ) < 320
            ) {
                this.state = this.states.CHASE;
            }

            if (this.state === this.states.CHASE) {
                const dx = this.scene.player.x - this.x;
                const dy = this.scene.player.y - this.y;

                const angle = Math.atan2(dy, dx);

                const speed = 100;
                this.body.setVelocity(Math.cos(angle) * speed, Math.sin(angle) * speed);

                if (this.x < this.scene.player.x) {
                    this.angle -= 5;
                } else {
                    this.angle += 5;
                }
            }
        }
    }
}